import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
  type GroupNode,
  NgDiagramGroupHighlightedDirective,
  type NgDiagramGroupNodeTemplate,
  NgDiagramNodeResizeAdornmentComponent,
  NgDiagramNodeSelectedDirective,
  NgDiagramPortComponent,
} from 'ng-diagram'
import { DaydicTypesIconNames } from 'src/app/shared/enums/enums'
import { Quiz } from 'src/app/shared/models/main/quiz'

export interface GroupNodeData {
  quiz: Quiz
}

@Component({
  selector: 'ddc-canvas-node-quiz',
  imports: [
    NgDiagramPortComponent,
    NgDiagramNodeSelectedDirective,
    NgDiagramGroupHighlightedDirective,
    CommonModule,
    NgDiagramNodeResizeAdornmentComponent,
    MatIcon,
  ],
  templateUrl: './quiz-node.component.html',
  styleUrls: ['./quiz-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.ng-diagram-port-hoverable]': 'true',
  },
})
export class CanvasQuizNodeComponent implements NgDiagramGroupNodeTemplate<GroupNodeData> {
  node = input.required<GroupNode<GroupNodeData>>()
  title = signal<string>('Quiz')
  icon = signal<string>(DaydicTypesIconNames.QUIZ)
}
